const REWARD_BASE_URL = process.env.REACT_APP_REWARDS_URL;

export async function fetchBanner(adId) {
  try {
    const response = await fetch(`${REWARD_BASE_URL}/banner?adId=${adId}`);
    if (!response.ok) throw new Error("Failed to fetch banner");
    return await response.json();
  } catch (error) {
    console.error("Error fetching banner:", error);
    return null;
  }
}

export async function sendRewardEvent(token, adId, eventType, message = "") {
  try {
    await fetch(`${REWARD_BASE_URL}/reward`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ adToken: token, state: eventType.toUpperCase(), message }),
    });
  } catch (error) {
    console.error(`Error sending event (${eventType}):`, error);
  }
}


export async function fetchAdTag(token) {
    try {
      const response = await fetch(`${REWARD_BASE_URL}/adtag?token=${token}`);
      if (!response.ok) throw new Error("Failed to fetch ad tag");
  
      const data = await response.text();
      console.log(`data = ${data}`);
      
      
      // Ensure the adTag exists and is not empty
      if (!data) {
        console.warn("No ads available for this user.");
        return null;
      }
  
      return data;
    } catch (error) {
      console.error("Error fetching ad tag:", error);
      return null;
    }
}